<template>
    <div class="container">
        <!-- 第一张图片：对应 targetUrl -->
        <!-- <img v-if="!isIframeShow" src="../assets/screen5.png" alt="点击打开监控大屏1" class="screen-img"
            @click="openIframeInCurrentPage('screen')" style="margin-left: 10px;"> -->
        <!-- 第二张图片：对应 targetUrl1 -->
        <!-- <img v-if="!isIframeShow" src="../assets/screen1.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen1')">

        <img v-if="!isIframeShow" src="../assets/screen2.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen2')">

        <img v-if="!isIframeShow" src="../assets/screen6.png" alt="前厅" class="screen-img"
            @click="openIframeInCurrentPage('screen3')">
        <img v-if="!isIframeShow" src="../assets/screen4.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen4')">
        <img v-if="!isIframeShow" src="../assets/screen3.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen5')">
        <img v-if="!isIframeShow" src="../assets/screen.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen6')">
        <img v-if="!isIframeShow" src="../assets/screen7.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen7')">
        <img v-if="!isIframeShow" src="../assets/screen8.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen8')">
        <img v-if="!isIframeShow" src="../assets/screen9.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen9')">
        <img v-if="!isIframeShow" src="../assets/screen10.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen10')">
        <img v-if="!isIframeShow" src="../assets/screen11.png" alt="点击打开监控大屏2" class="screen-img"
            @click="openIframeInCurrentPage('screen11')"> -->
        <img v-if="!isIframeShow" src="../assets/screen12.png" alt="消毒柜" class="screen-img" style="margin-left: 10px;"
            @click="openIframeInCurrentPage('screen12')">
        <img v-if="!isIframeShow" src="../assets/screen13.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen13')">

        <img v-if="!isIframeShow" src="../assets/screen14.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen14')">
        <img v-if="!isIframeShow" src="../assets/screen15.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen15')">



        <img v-if="!isIframeShow" src="../assets/screen1.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen')">
        <img v-if="!isIframeShow" src="../assets/screen.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen1')">
        <img v-if="!isIframeShow" src="../assets/screen2.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen2')">
        <img v-if="!isIframeShow" src="../assets/screen3.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen3')">
        <img v-if="!isIframeShow" src="../assets/screen4.png" alt="消毒柜" class="screen-img"
            @click="openIframeInCurrentPage('screen4')">
        <img v-if="!isIframeShow" src="../assets/screen11.png" alt="排风" class="screen-img"
            @click="openIframeInCurrentPage('screen5')">
        <img v-if="!isIframeShow" src="../assets/screen6.png" alt="前厅" class="screen-img"
            @click="openIframeInCurrentPage('screen6')">
        <img v-if="!isIframeShow" src="../assets/screen10.png" alt="设备" class="screen-img"
            @click="openIframeInCurrentPage('screen7')">
        <img v-if="!isIframeShow" src="../assets/screen9.png" alt="洗餐盘机" class="screen-img"
            @click="openIframeInCurrentPage('screen8')">
        <img v-if="!isIframeShow" src="../assets/screen8.png" alt="洗碗机" class="screen-img"
            @click="openIframeInCurrentPage('screen9')">
        <img v-if="!isIframeShow" src="../assets/screen7.png" alt="燃气" class="screen-img"
            @click="openIframeInCurrentPage('screen10')">
        <img v-if="!isIframeShow" src="../assets/screen5.png" alt="燃气" class="screen-img"
            @click="openIframeInCurrentPage('screen11')">
        <!-- 嵌入式 iframe + 返回按钮（点击图片后显示） -->
        <div v-show="isIframeShow" class="iframe-container">
            <!-- 返回按钮：悬浮在iframe上方 -->
            <button class="back-btn" @click="backToImage">返回</button>
            <iframe ref="screenIframe" :src="iframeUrl" frameborder="0" class="screen-iframe"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            iframeUrl: "about:blank", // iframe默认空白
            // 存储不同图片对应的网址
            urlMap: {
                // screen: "http://120.224.150.2:15012/screen1/#/",
                // screen1: "http://120.224.150.2:15012/screen/#/",
                // screen2: "http://120.224.150.2:15012/screen2/#/",
                // screen3: "http://120.224.150.2:15012/screen3/#/",
                // screen4: "http://120.224.150.2:15012/screen4/#/",
                // screen5: "http://120.224.150.2:15012/screen5/#/",
                // screen6: "http://120.224.150.2:15012/screen6/#/",
                // screen7: "http://120.224.150.2:15012/screen7/#/",
                // screen8: "http://120.224.150.2:15012/screen8/#/",
                // screen9: "http://120.224.150.2:15012/screen9/#/",
                // screen10: "http://120.224.150.2:15012/screen10/#/",
                // screen11: "http://120.224.150.2:15012/screen11/#/"
                // 中研
                screen: "https://www.zhongyanzhiye.com:81/screen/#/",
                screen1: "https://www.zhongyanzhiye.com:81/screen1/#/",
                screen2: "https://www.zhongyanzhiye.com:81/screen2/#/",
                screen3: "https://www.zhongyanzhiye.com:81/screen3/#/",
                screen4: "https://www.zhongyanzhiye.com:81/screen4/#/",
                screen5: "https://www.zhongyanzhiye.com:81/screen5/#/",
                screen6: "https://www.zhongyanzhiye.com:81/screen6/#/",
                screen7: "https://www.zhongyanzhiye.com:81/screen7/#/",
                screen8: "https://www.zhongyanzhiye.com:81/screen8/#/",
                screen9: "https://www.zhongyanzhiye.com:81/screen9/#/",
                screen10: "https://www.zhongyanzhiye.com:81/screen10/#/",
                screen11: "https://www.zhongyanzhiye.com:81/screen11/#/",


                screen12: "https://www.zhongyanzhiye.com:81/screen12/#/",
                screen13: "https://www.zhongyanzhiye.com:81/screen13/#/",
                screen14: "https://www.zhongyanzhiye.com:81/screen14/#/",
                screen15: "https://www.zhongyanzhiye.com:81/screen15/#/"

            },

            isIframeShow: false // 控制图片/iframe的显示状态
        };
    },
    methods: {
        // 点击图片：根据图片类型加载对应网址
        openIframeInCurrentPage(type) {
            // 根据传入的类型，获取对应的网址
            this.iframeUrl = this.urlMap[type];
            this.isIframeShow = true; // 切换状态：隐藏图片、显示iframe
        },
        // 点击返回按钮：隐藏iframe并显示图片
        backToImage() {
            this.isIframeShow = false; // 切换状态：显示图片、隐藏iframe
            this.iframeUrl = "about:blank"; // 清空iframe内容
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
    padding: 10px; // 保留少量内边距，避免内容贴边
}

// 图片样式（20%宽度，添加点击手型提示）
.screen-img {
    width: 20%;
    height: auto;
    cursor: pointer; // 鼠标悬浮显示手型
    margin-bottom: 10px;

    // 多张图片之间增加间距
    &+& {
        margin-left: 10px;
    }

    &:active {
        opacity: 0.8; // 点击反馈
    }
}

// iframe容器：用于包裹iframe和返回按钮
.iframe-container {
    position: relative; // 为返回按钮提供定位参考
    width: 100%;
    height: 90vh;
}

// 返回按钮样式：悬浮在iframe右上角
.back-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 999; // 确保按钮在iframe上方显示
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background: #ff4d4f; // 红色突出返回功能
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.9; // 悬浮反馈
    }

    &:active {
        opacity: 0.8; // 点击反馈
    }
}

// iframe样式（铺满整个容器高度）
.screen-iframe {
    width: 100%;
    height: 90vh;
    border: none;
    background: #f5f5f5; // 未加载时显示浅灰色
}
</style>